<template>
  <el-button
    v-if="hasDownloadLogId"
    type="text"
    :disabled="loading || disabled"
    class="download-file-button"
    @click="download"
  >
    <i class="el-icon-download"></i>
    {{ loading ? $t('downloadLogUi.loading') : displayLabel }}
  </el-button>
</template>

<script>
import { request } from '@/utils/utils.js'

export default {
  name: 'DownloadFileButton',
  props: {
    downloadLogId: {
      type: [String, Number],
      default: '',
    },
    apiUrl: {
      type: String,
      default: 'api/dashboard/download-log/temp-url',
    },
    paramName: {
      type: String,
      default: 'download_log_id',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    hasDownloadLogId () {
      return this.downloadLogId !== '' && this.downloadLogId !== null && this.downloadLogId !== undefined
    },
    displayLabel () {
      return this.label || this.$t('downloadLogUi.download')
    },
  },
  methods: {
    async download () {
      if (this.loading || this.disabled || !this.hasDownloadLogId) return

      this.loading = true
      const token = localStorage.getItem('Authorization')
      try {
        const response = await request({
          method: 'post',
          url: `${this.apiUrl}?access_token=${token}`,
          params: {
            [this.paramName]: this.downloadLogId,
          },
          headers: {
            'Content-Type': 'application/json',
          },
        })
        if (!response) return

        const { code, data, msg } = response.data
        if (String(code) !== '10000' || !data) {
          throw new Error(msg || this.$t('downloadLogUi.tempUrlUnavailable'))
        }

        window.open(data, '_blank')
      } catch (error) {
        this.showToast(error.message || this.$t('downloadLogUi.createTempUrlFailed'), {
          icon: 'fa-exclamation-circle',
          position: 'top-center',
          duration: 3000,
          fullWidth: false,
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.download-file-button {
  padding: 0;
  margin-right: 12px;
  font-size: inherit;
  color: $vue-green;

  &:hover,
  &:focus {
    color: lighten($vue-green, 8%);
  }

  &.is-disabled {
    color: $gray;
  }

  .el-icon-download {
    margin-right: 4px;
  }
}
</style>
